import { Box, Heading, Tabs, TabList, Tab } from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';

export enum PortfolioOverviewTabOptionKeys {
  facilities = 'facilities',
  risk = 'risk',
  strats = 'strats',
  reportBuilder = 'reportBuilder',
}
type PortfolioOverviewTabType = {
  key: PortfolioOverviewTabOptionKeys;
  label: string;
  route: string;
};
const portfolioOverviewTabOptions: Record<
  PortfolioOverviewTabOptionKeys,
  PortfolioOverviewTabType
> = {
  facilities: {
    key: PortfolioOverviewTabOptionKeys.facilities,
    label: 'Facilities',
    route: '/portfolio/overview/facilities',
  },
  risk: {
    key: PortfolioOverviewTabOptionKeys.risk,
    label: 'Risk',
    route: '/portfolio/overview/risk',
  },
  strats: {
    key: PortfolioOverviewTabOptionKeys.strats,
    label: 'Strats',
    route: '/portfolio/overview/strats',
  },
  reportBuilder: {
    key: PortfolioOverviewTabOptionKeys.reportBuilder,
    label: 'Report Builder',
    route: '/portfolio/overview/report-builder',
  },
};

type PortfolioOverviewTemplateProps = {
  selectedTab: PortfolioOverviewTabOptionKeys;
  children: React.ReactNode;
};
export const PortfolioOverviewTemplate = ({
  selectedTab,
  children,
}: PortfolioOverviewTemplateProps) => {
  const flags = useFeatureFlags();
  const navigate = useNavigate();

  // can configure feature flags for specific tabs as needed in the future
  // to conditionally render tabs
  const tabs = useMemo<PortfolioOverviewTabType[]>(() => {
    return [
      portfolioOverviewTabOptions.facilities,
      portfolioOverviewTabOptions.risk,
      ...(flags.showLenderPortfolioOverviewStrats
        ? [portfolioOverviewTabOptions.strats]
        : []),
      ...(flags.showLenderPortfolioOverviewStrats
        ? [portfolioOverviewTabOptions.reportBuilder]
        : []),
    ];
  }, [flags]);

  return (
    <Box>
      <Box>
        <Heading as="h2">Portfolio</Heading>
      </Box>
      <Tabs
        variant="line"
        index={tabs.findIndex(({ key }) => key === selectedTab)}
        colorScheme="blue"
        background="white"
      >
        <TabList>
          {tabs.map(({ route, label, key }) => (
            <Tab
              key={key}
              onClick={() => {
                navigate(route);
              }}
            >
              {label}
            </Tab>
          ))}
        </TabList>
      </Tabs>
      <Box mt="32px">{children}</Box>
    </Box>
  );
};
